import type { Framework } from '@toeverything/infra';

import { GuardService } from '../permissions';
import { WorkspaceScope } from '../workspace';
import { DocMetaRepairService } from './services/doc-meta-repair';

export function configureDocMetaRepairModule(framework: Framework) {
  framework.scope(WorkspaceScope).service(DocMetaRepairService, [GuardService]);
}
